module.exports = __webpack_public_path__ + "img/176.meat.2f596b97.svg";